import * as angular from "angular";

interface StatusStarted {
    startedOn?: string;
}

const STAFF_IMPORT_STATUS = "staffImportStatus";
const STAFF_TEST_IMPORT_STATUS = "staffTestImportStatus";
const STUDENT_IMPORT_STATUS = "importStatus";
const STUDENT_TEST_IMPORT_STATUS = "testImportProgress";

export class LinkPathService {
    /* @ngInject */
    constructor(private $route: angular.route.IRouteService) {}

    getStudentTabPath():string {
        const hasFullyImportedMostRecently = this.isRealImportMostRecent(STUDENT_TEST_IMPORT_STATUS, STUDENT_IMPORT_STATUS);

        return hasFullyImportedMostRecently ? "student-import-records" : "import-student-data";
    }

    getStaffTabPath():string {
        const hasFullyImportedMostRecently = this.isRealImportMostRecent(STAFF_TEST_IMPORT_STATUS, STAFF_IMPORT_STATUS);

        return hasFullyImportedMostRecently ? "staff-import-records" : "import-staff-data";
    }

    private isRealImportMostRecent(testStatusName: string, realStatusName: string):boolean {
        const locals = this.$route.current.locals;

        const testStatus:StatusStarted = locals[testStatusName];
        const realStatus:StatusStarted  = locals[realStatusName];
        
        if ( !testStatus || !realStatus || !testStatus.startedOn || !realStatus.startedOn) {
            return false;
        }

        return (new Date(testStatus.startedOn)) < (new Date(realStatus.startedOn));
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/link-path/link-path.service.ts